import React from "react";
import classNames from "classnames";
import Head from "next/head";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";


// core components
import Header from "components/Header/Header";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import { Link, Grid } from "@material-ui/core";
import styles from "assets/jss/nextjs-material-kit/pages/landingPage.js";
import customStyles from "assets/jss/custom/customStyles.js";

const useStyles = makeStyles({
  ...styles,
  ...customStyles,
});

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default function PressePage(props) {
  const dashboardRoutes = [];
  const { ...rest } = props;
  const classes = useStyles();

  const params = {
    title: "Affiliates",
    teaser: "",
  };

  return (
    <div>
      <Head>
        <title>{params.title} | getasugar - das Sugar Dating Portal</title>
        <meta name="description" content={params.teaser} />
      </Head>
      <Header
        color="primary"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        {...rest}
      />
      <div className={classes.main} style={{ marginTop: "3em" }}>
        <div>
          <div className={classes.container}>
            <div className={classNames(classes.hasPaddingTop)}>
              <Grid container
                justify="center"
                className={classNames(
                  classes.hasPaddingTop,
                  classes.contentContainer,
                  classes.hasShadow
                )}
              >
                <Grid item xs={12} key='title'>
                  <h2 className={classes.h2}>{params.title}</h2>
                </Grid>

                <Grid item xs={12} key='press'>
                  <p>
                    Wir bieten Websites, Blogs und Digital Creators attraktive Provisionen auf vermittelte Neu-Mitglieder und Umsätze. Eine Kooperation auf Augenhöhe und faire Vergütungsmodelle sind dabei selbstverständlich. Alle Affiliate Partner werden individuell durch unser Team betreut.
                  </p>
                  <p>
                    Bewirb dich jetzt mit detaillierten Informationen zu deiner Website oder Kanälen. Wir freuen uns bereits jetzt auf die potentielle Zusammenarbeit.
                  </p>
                  <p>
                    Publisher Bewerbungen nehmen wir unter der folgenden E-Mailadresse entgegen:
                  </p>
                  <p>
                    <a href="mailto:affiliates@lovelyvibes.de">affiliates@lovelyvibes.de</a>
                  </p>
                </Grid>
              </Grid>              
            </div>
          </div>
        </div>
      </div>
      <Footer withSignup={false} />
    </div>
  );
}
